import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ShoesGuidePage from "@/pages/article-shoes/page";
import HoodiesGuidePage from "@/pages/article-hoodies/page";
import BagsGuidePage from "@/pages/article-bags/page";
import AccessoriesGuidePage from "@/pages/article-accessories/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-shoes-guide",
    element: <ShoesGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-hoodies-guide",
    element: <HoodiesGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-bags-guide",
    element: <BagsGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-accessories-guide",
    element: <AccessoriesGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;